import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './app/store/store';
import './registerServiceWorker';
import './app/styles/styles.scss';
import vuetify from './plugins/vuetify';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import '@fortawesome/fontawesome-free/css/all.css';
import i18n from './config/i18n';
import './config/notifications';
import './config/progressBar';
import initialize from '@/config/initialize';

store.commit('setLoadingState', true);

Vue.config.productionTip = false;
initialize(store);

export default new Vue({
  router,
  store,
  // @ts-ignore
  vuetify,
  i18n,
  render: h => h(App),
}).$mount('#app');
